"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class LocaleService {
  constructor(_ref) {
    let {
      i18n,
      options
    } = _ref;
    this.i18n = void 0;
    this.i18n = i18n;
    this.localeString = this.localeString.bind(this);
    this.formatPrice = this.formatPrice.bind(this);
    this.options = options;
  }
  localeString(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.i18n) {
      return key;
    }
    const marketTranslation = this.i18n(`${this.options.market}.${key}`, options);
    const translation = this.i18n(key, options);
    const finalTranslation = marketTranslation.includes(key) || key.includes(marketTranslation) ? translation : marketTranslation;
    return finalTranslation || (options.allowMissingKey ? null : key);
  }

  /**
   * Currency specific parsing
   * @param price {string}
   * @param currency {string}
   * @returns {string}
   */
  parsePrice(price, currency) {
    switch (currency) {
      case 'EUR':
        return price.replace(/\s/, '');
      case 'USD':
        return price.replace('US', '').replace(/^([\d.,]+)\s*(.*?)$/, '$2$1');
      case 'ZAR':
        return price.replace(/\s+/g, '').replace('ZAR', 'R').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      case 'PEN':
        {
          return price.replace(/\s+/g, '').replace(/(.)(?=(\d{3}))/g, ',').replace(/((,)(?=(\d{2})))+(?!\d{3})/g, '.').replace(/([\d,]+(?:\.\d+)?)\s*(\w+)/, '$2 $1').replace('PEN', 'S/').replace(".00", "");
        }
      default:
        return price;
    }
  }
  formatPrice(amount) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const locale = this.localeString('locale');
    const currency = this.localeString('currency');
    const {
      maximumFractionDigits,
      minimumFractionDigits
    } = {
      ...this.options,
      ...options
    };
    const formatOptions = {
      style: 'currency',
      currency,
      maximumFractionDigits,
      minimumFractionDigits
    };
    const formatter = new Intl.NumberFormat(locale, formatOptions);
    const formattedPrice = formatter.format(amount);
    return this.parsePrice(formattedPrice, currency);
  }
}
var _default = LocaleService;
exports.default = _default;